import { homeService } from 'api/homeService';
import { GET_ADVANCED_SEARCH_FAILURE, GET_ADVANCED_SEARCH_REQUEST, GET_ADVANCED_SEARCH_SUCCESS, GET_SIMPLE_SEARCH_FAILURE, GET_SIMPLE_SEARCH_REQUEST, GET_SIMPLE_SEARCH_SUCCESS, SEARCH_KEYWORD_UPDATE_SUCCESS } from 'constants/actionTypes';
import { advancedSearchPayloadType, simpleSearchPayloadType } from 'type/homeType';

export const searchActions = {
  simpleSearch,
  advancedSearch,
  getSearchValues
};

function simpleSearch(payload: simpleSearchPayloadType) {
  return async (dispatch: any) => {
    dispatch(request(GET_SIMPLE_SEARCH_REQUEST));
    homeService
      .fetchSimpleSearch(payload)
      .then((resp) => resp.json())
      .then((data) => {
        if (data?.error || data?.message) {
          dispatch(failure(GET_SIMPLE_SEARCH_FAILURE, data.message || 'Error fetching recent records'));
        } else {
          dispatch(success(GET_SIMPLE_SEARCH_SUCCESS, data));
        }
      })
      .catch((error) => {
        dispatch(failure(GET_SIMPLE_SEARCH_FAILURE, error));
      });
  };
}

function advancedSearch(payload: advancedSearchPayloadType) {
  return async (dispatch: any) => {
    dispatch(request(GET_ADVANCED_SEARCH_REQUEST));
    homeService
      .fetchRecentRecords(payload)
      .then((resp) => resp.json())
      .then((data) => {
        if (data?.error || data?.message) {
          dispatch(failure(GET_ADVANCED_SEARCH_FAILURE, data.message || 'Error fetching recent records'));
        } else {
          dispatch(success(GET_ADVANCED_SEARCH_SUCCESS, data));
        }
      })
      .catch((error) => {
        dispatch(failure(GET_ADVANCED_SEARCH_FAILURE, error));
      });
  };
}

function getSearchValues(keyword: string, pagination?: { pageNumber: number; pageSize: number }) {
  return (dispatch: any) => {
    dispatch({type:SEARCH_KEYWORD_UPDATE_SUCCESS,payload: { keyword,pagination}});
  };
}


function request(type:string) {
  return { type: type };
}

function success(type:string,data:any) {
  return { type, payload: data};
}

function failure(type:string,message:string) {
  return { type, payload: { message } };
}